var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.221,
    height: 27.221,
    viewBox: "0 0 27.221 27.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add",
    transform: "translate(-552.826 -298.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_circle_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M112.536-839.584h2.149v-5.731h5.731v-2.149h-5.731v-5.731h-2.149v5.731h-5.731v2.149h5.731Zm1.077,6.805a13.259,13.259,0,0,1-5.308-1.072,13.746,13.746,0,0,1-4.322-2.909,13.746,13.746,0,0,1-2.91-4.321A13.247,13.247,0,0,1,100-846.387a13.259,13.259,0,0,1,1.072-5.308,13.748,13.748,0,0,1,2.909-4.322,13.746,13.746,0,0,1,4.321-2.91A13.247,13.247,0,0,1,113.608-860a13.26,13.26,0,0,1,5.308,1.072,13.747,13.747,0,0,1,4.322,2.909,13.746,13.746,0,0,1,2.91,4.321,13.247,13.247,0,0,1,1.072,5.307,13.259,13.259,0,0,1-1.072,5.308,13.747,13.747,0,0,1-2.909,4.322,13.744,13.744,0,0,1-4.321,2.91A13.246,13.246,0,0,1,113.613-832.779Zm0-2.149a11.062,11.062,0,0,0,8.131-3.331,11.062,11.062,0,0,0,3.331-8.131,11.062,11.062,0,0,0-3.331-8.131,11.062,11.062,0,0,0-8.131-3.331,11.062,11.062,0,0,0-8.131,3.331,11.062,11.062,0,0,0-3.331,8.131,11.062,11.062,0,0,0,3.331,8.131A11.062,11.062,0,0,0,113.611-834.928ZM113.611-846.389Z",
    transform: "translate(452.826 1158.389)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/Add-circle.8164a3e915d6f0bf187f80910f28203c.svg";
export { ForwardRef as ReactComponent };